module.exports = __webpack_public_path__ + "img/headphones.ded3b849.webp";